import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
/* import NProgress from "nprogress"; */
import "nprogress/nprogress.css";
import axios from "axios";
import VueAxios from "vue-axios";

// IMPORTACIÓN VUE TABLE 2
import { ServerTable, ClientTable, Event } from "vue-tables-2";
// IMPORTACIÓN DE FIREBASE
import { firebase, auth } from "../firebase";
import VueQrcodeReader from "vue-qrcode-reader";

const eventBus = new Vue();

/* Vue.use(NProgress); */
Vue.component("multiselect", Multiselect);
Vue.component("v-select", vSelect);
Vue.use(VueRouter);
Vue.use(ClientTable);
Vue.use(store);
Vue.use(VueAxios, axios);
Vue.use(VueQrcodeReader);

const routes = [
  {
    path: "/",
    name: "LoadingTo",
    component: () => import("../views/LoadingTo.vue"),
    meta: {
      autentificado: false,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
    meta: {
      autentificado: false,
    },
  },
  // { path: '/', name: 'login', component: login },
  {
    path: "/inicio",
    name: "inicio",
    component: () => import("../views/inicio.vue"),
    meta: {
      autentificado: true,
    },
  },
  // { path: '/inicio', name: 'inicio', component: inicio },
  {
    path: "/querys",
    name: "querys",
    component: () => import("../views/querys.vue"),
    meta: {
      autentificado: true,
    },
  },
  // { path: '/querys', name: 'querys', component: querys },
  {
    path: "/perfil",
    name: "perfil",
    component: () => import("../views/perfil.vue"),
    meta: {
      autentificado: true,
    },
  },
  // { path: '/perfil', name: 'perfil', component: perfil },
  // {
  //   path: "/administracion",
  //   name: "administracion",
  //   component: () => import("../views/administracion.vue"),
  //   meta: {
  //     autentificado: true,
  //   },
  // },
  // -------------------- //
  {
    path: "/clientes",
    name: "Clientes",
    component: () => import("../views/Administracion/Clientes.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/procesos",
    name: "Procesos",
    component: () => import("../views/Administracion/Procesos.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/peligros",
    name: "Peligros",
    component: () => import("../views/Administracion/Peligros.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/efectosPosibles",
    name: "EfectosPosibles",
    component: () => import("../views/Administracion/EfectosPosibles.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/controlExistente",
    name: "ControlExistente",
    component: () => import("../views/Administracion/ControlExistente.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/usuario",
    name: "Usuario",
    component: () => import("../views/Administracion/Usuarios.vue"),
    meta: { autentificado: true, },
  },
  {
    path: "/regionales",
    name: "Regionales",
    component: () => import("../views/Administracion/Regionales.vue"),
    meta: { autentificado: true, },
  },
  {
    path: "/administracion/novedades",
    name: "AdministracionNovedades",
    component: () => import("../views/Administracion/Novedades/Novedades.vue"),
    meta: { autentificado: true, },
  },
  {
    path: "/administracion/novedad/nueva",
    name: "AdministracionNovedadNueva",
    component: () => import("../views/Administracion/Novedades/Novedad.vue"),
    meta: { autentificado: true, },
  },
  {
    path: "/administracion/novedad/editar/:id",
    name: "AdministracionNovedadEditar",
    component: () => import("../views/Administracion/Novedades/Novedad.vue"),
    meta: { requiereAuth: true },
  },
  {
    path: "/novedades",
    name: "Novedades",
    component: () => import("../views/Novedades/Novedades.vue"),
    meta: { requiereAuth: true },
  },
  {
    path: "/novedades/:id",
    name: "NovedadesConsultar",
    component: () => import("../views/Novedades/Consultar.vue"),
    meta: { requiereAuth: true },
  },



  {
    path: "/descripcion_peligro",
    name: "descripcion_peligro",
    component: () => import("../views/mrd.vue"),
    meta: { autentificado: true, },
  },
 

  // -------------------- //

  {
    path: "/matriz_peligro",
    name: "matriz_peligro",
    component: () => import("../views/matriz-peligro.vue"),
    meta: {
      autentificado: true,
    },
    // path: '/matriz-peligro', name: 'matriz_peligro', component: matriz_peligro,
  },
  {
    path: "/registro_centro_trabajo",
    name: "registro_centro_trabajo",
    component: () => import("../views/mmp.vue"),
    meta: {
      autentificado: true,
    },
    // path: 'registro-centro-trabajo', name: 'registro_centro_trabajo', component: mmp
  },
  {
    path: "/seleccionar_proceso",
    name: "seleccionar_proceso",
    component: () => import("../views/msp.vue"),
    meta: {
      autentificado: true,
    },
    // path: 'seleccionar-proceso', name: 'seleccionar_proceso', component: msp
  },
  {
    path: "/identificar_peligros",
    name: "identificar_peligros",
    component: () => import("../views/mip.vue"),
    meta: {
      autentificado: true,
    },
    // path: 'identificar-peligros', name: 'identificar_peligros', component: mip
  },
  {
    path: "/evaluacion_riesgos",
    name: "evaluacion_riesgos",
    component: () => import("../views/mer.vue"),
    meta: {
      autentificado: true,
    },
    // path: 'evaluacion-riesgos', name: 'evaluacion_riesgos', component: mer
  },
  {
    path: "/medidas_intervencion",
    name: "medidas_intervencion",
    component: () => import("../views/mmi.vue"),
    meta: {
      autentificado: true,
    },
    // path: 'medidas-intervencion', name: 'medidas_intervencion', component: mmi
  },
  {
    path: "/lista_clientes",
    name: "lista_clientes",
    component: () => import("../views/mlc/mlc.vue"),
    meta: {
      autentificado: true,
    },
    // path: '/lista-clientes', name: 'lista_clientes', component: mlc
  },
  {
    path: "/lista_clientes/consultar_matriz/:id",
    name: "consultar_matriz",
    component: () => import("../views/mlc/ConsultarMatriz.vue"),
    meta: {
      autentificado: true,
    },
    // path: '/lista-clientes', name: 'lista_clientes', component: mlc
  },
  {
    path: "/lista_clientes/importar_matriz",
    name: "importar_matriz",
    component: () => import("../views/mlc/ImportarMatriz.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/lista_clientes/importar_matriz/:id",
    name: "editar_importar_matriz",
    component: () => import("../views/mlc/ImportarMatriz.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/lista_clientes/copiar_matriz/:id",
    name: "copiar_matriz",
    component: () => import("../views/mlc/CopiarMatriz.vue"),
    meta: {
      autentificado: true,
    },
    // path: '/lista-clientes', name: 'lista_clientes', component: mlc
  },
  {
    path: "/qmatriz/:id",
    name: "qmatriz",
    component: () => import("../views/qmatriz.vue"),
    meta: {
      autentificado: false,
    },
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/404.vue"),
    meta: {
      autentificado: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});
// GUARDIAS DE NAVEGACIÓN
router.beforeEach((to, from, next) => {
  // CERRAR TODOS LOS MODALES
  $(".modal").modal("hide");
  // USUARIO ACTUAL
  let usuario = store.state.user_auth;
  // AUTORIZACIÓN
  let autorizacion = to.matched.some((record) => record.meta.autentificado);
  // CONDICIONALES DE REDIRECCIÓN
  if (autorizacion && !usuario) {
    // NO PUEDE ACCEDER A LA RUTA
    next("/");
  } else if (!autorizacion && usuario) {
    // NO PUEDE ACCEDER A LA RUTA
    next();
  } else {
    // PUEDE ACCEDER A LA RUTA
    next();
  }
});
router.beforeResolve((to, from, next) => {
  // SI NO INICIA LA PÁGINA DE CARGA
  if (to.name) {
    // INICIACIÓN DE LA RUTA DE LA BARRA DE PROGRESO
    /* NProgress.start(); */
  }
  next();
});
router.afterEach((to, from) => {
  // FINALIZACIÓN DE LA ANIMACIÓN DE LA RUTA DE LA BARRA DE PROGRESO
  /* NProgress.done(); */
});
// EXPORTACIÓN POR DEFECTO DEL ROUTER
export default router;